export default "__VITE_ASSET__oJW$uN6t__"